import React from "react";
import CustomTable from "../../../../components/table/CustomTable";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import DisplayView from "../../../../components/DisplayView";
import {getViewTypeByName} from "../../../../enums/ViewType";
import GuardRosterTableApp from "../Functionality/GuardRosterTableApp";

/**
 * Table view of the roster of the guards.
 */
const GuardRosterTable = ({
    selectedList, setSelectedList, modified, setModified, setDeleteModal, isAllChecked, setIsAllChecked,
    searchElement, setSearchElement, setSearch, setSimpleSearch, setBodyForExport, setCriteria, finalArray,
    option, view, handleView, goUpdate, canUpdate, canDelete, emptyRoster,
}) => {
    const {
        tableId,
        searchId,
        setSearchResults,
        rowsPerPage,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        getActionsButtons,
    } = GuardRosterTableApp({
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setDeleteModal,
        setIsAllChecked,
        searchElement,
        setBodyForExport,
        setCriteria,
        finalArray,
        option,
        view,
        goUpdate,
        canUpdate,
        canDelete,
    });

    return (
        <>
            <div className="d-flex">
                <DisplayView view={view} setView={handleView} left={0}/>
                <div className={"ml-2 w-100"}>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                        viewType={getViewTypeByName(view)}
                    />
                </div>
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={canDelete}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                childrenNotInformation={tbody?.data?.length === 0 ? emptyRoster : undefined}
            />
            {pagination()}
        </>
    );
};

export default GuardRosterTable;
